import React from 'react';
import { View, StyleSheet, Text, Image, Platform } from 'react-native';
import { Tile, mappedTitles, UserDataConsumer, mappedIcons, Theme } from 'fitbeat.react-native-components';
import { translate } from 'react-i18next';
import { TrackingDateSelector } from './tracking-date-dropdown';
import { connect } from 'react-redux';
import { getTrackingStats } from '../actions';
import { UserServiceClient } from 'fitbeat.api-clients';
import { getApiConfig } from '../../config';
import { AuthTokenBuilder } from '../../utils/authTokenBuilder';
import { GoogleAnalytics } from '../../services/google-analytics';
import { moderateScale } from 'react-native-size-matters';

const isWeb = Platform.OS === 'web' && window.innerWidth >= 550;
const isSmallMobile = window.innerWidth <= 350;
class TrackingFitnessGoal extends React.PureComponent {

  render() {
    const { t } = this.props;
    const icon = mappedIcons[this.props.longTermGoal]({}, Theme.WHITE);
    return (
      <Tile customStyle={styles.container}>
        <View style={styles.iconContainer}>
          {icon}
        </View>
        <View style={styles.goalHeader}>
          <Text style={styles.title}>{t('longTermFitnessGoal')}</Text>
          <Text style={styles.goal}>{mappedTitles[this.props.longTermGoal].toUpperCase()}</Text>
        </View>
        <View style={styles.separator} />
        <View style={styles.dropDownContainer}>
          <Text style={styles.monthlyTitle}>{t('monthlyDashboard')}</Text>
          <TrackingDateSelector monthAndYearRange={this.props.monthAndYearRange} selectedMonthAndYear={this.props.selectedMonthAndYear}
            getTrackingStats={this.props.getTrackingStats} />
        </View>
      </Tile>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    backgroundColor: '#4E4D4D',
    justifyContent: 'space-evenly',
    zIndex: 1,
  },
  separator: {
    borderRightColor: '#979797',
    borderRightWidth: 1,
    height: '80%',
    alignSelf: 'center',
    alignContent: 'center',
  },
  goalHeader: {
    flexDirection: 'column',
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
    zIndex: 1,
    alignItems: 'flex-start'},
  goal: {
    fontSize: isSmallMobile ? 11 : 14,
    fontFamily: Theme.Custom800,
    letterSpacing: 0,
    lineHeight: 25,
    color: '#FFFFFF',
    alignSelf: 'flex-start',
    marginTop: 3,
  },
  title: {
    fontWeight: '200',
    color: 'white',
    alignSelf: 'flex-start',
    fontSize: isSmallMobile ? 11 : 14,
  },
  monthlyTitle: {
    color: 'white',
    alignSelf: 'flex-start',
    fontSize: isSmallMobile ? 11 : 14,
    fontFamily: Theme.Custom800,
  },
  titlePaddingWithIcon: {
    paddingLeft: 10,
  },
  iconContainer: {
    marginRight: isWeb ? -25 : 5,
    marginTop: 20,
    marginLeft: isSmallMobile ? 3 : isWeb ? -25 : 6,
    width: moderateScale(27, 2),
    height: moderateScale(24, 2),
  },
  dropDownContainer: {
    flexDirection: 'column',
    paddingTop: 10,
    marginLeft: 12,
    alignItems: 'flex-end',
    alignContent: 'flex-end',
    marginRight: isSmallMobile ? 3 : 0
  }
});
const mapStateToProps = (state) => {
  const { isLoading, error, monthAndYearRange, selectedMonthAndYear, workoutHeaderDateRange } = state.tracking.view;
  return {
    error,
    isLoading,
    monthAndYearRange,
    selectedMonthAndYear,
    workoutHeaderDateRange,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const userServiceClient = new UserServiceClient(getApiConfig(), fetch, console.log, new AuthTokenBuilder(), GoogleAnalytics);
  return {
    getTrackingStats: (date) => dispatch(getTrackingStats(userServiceClient, new Date(), date)),
  }
}

TrackingFitnessGoal = UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(TrackingFitnessGoal));
export default translate(['workoutHistory'])(TrackingFitnessGoal);
